// @flow

import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral[700]};
  margin-bottom: 8px;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  height: 50px;
  padding: 16px;
  border: 1px solid ${(props) => props.hasError ? props.theme.colors.feedback.error[500] : props.theme.colors.neutral[200]};
  border-radius: 8px;
  outline: none;
  font-size: 16px;
  color: ${props => props.theme.colors.neutral[700]};
  background-color: ${(props) => props.hasError ? props.theme.colors.feedback.error[100] : props.theme.colors.neutral.white};
  transition: border-color 0.2s, background-color 0.2s;

  &::placeholder {
    color: ${props => props.theme.colors.neutral[300]};
  }

  &:focus {
    border-color: ${(props) => props.hasError ? props.theme.colors.feedback.error[500] : props.theme.colors.new_primary[500]};
    ${(props) => !props.hasError && css`
      box-shadow: inset 0 0 0 1px ${props.theme.colors.new_primary[500]};
    `}
  }

  &:disabled {
    background-color: ${props => props.theme.colors.neutral[100]};
    color: ${props => props.theme.colors.neutral[500]};
    cursor: not-allowed;
  }
`;

export const ErrorText = styled.p`
  font-size: 12px;
  color: ${props => props.theme.colors.feedback.error[500]};
  margin-top: 4px;
`;
